import { observer } from 'mobx-react-lite'
import { ConflictDialog } from '@/features/legends/versioning/ConflictDialog'
import type { ConflictDialogViewModel } from './ConflictDialogViewModel'

const testId = 'legend-conflict-dialog'

export interface ConflictDialogContainerProps {
  vm: ConflictDialogViewModel
}

export const ConflictDialogContainer = observer(
  function ConflictDialogContainer({ vm }: ConflictDialogContainerProps) {
    return (
      <ConflictDialog
        showing={vm.modal.showing}
        lastUpdatedByName={vm.lastUpdatedBy.displayName}
        isForcePending={vm.force.pending}
        isKeepPending={vm.keep.pending}
        onForce={vm.force}
        onKeep={vm.keep}
        testId={testId}
      />
    )
  },
)
